import { render, staticRenderFns } from "./Perdu.vue?vue&type=template&id=bfd581dc&"
import script from "./Perdu.vue?vue&type=script&lang=js&"
export * from "./Perdu.vue?vue&type=script&lang=js&"
import style0 from "./Perdu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports